import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import _ from 'lodash';
import moment from 'moment';
const confirm = Modal.confirm;

import { descargarCSV } from '../../../components/administracion/funciones/descargarCSV';

import { errorService } from '../../../graphql/utils/utils';
import TablaTraspasos from './TablaTraspasos';

import getTraspasos from '../../../graphql/querys/rrhh/getTraspasos.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import deleteTraspaso from '../../../graphql/mutations/rrhh/deleteTraspaso.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import getTraspasosConFiltros from '../../../graphql/querys/rrhh/getTraspasosConFiltros.graphql';
import getCantidadTraspasosPorFiltros from '../../../graphql/querys/rrhh/getCantidadTraspasosPorFiltros.graphql';
import getTraspasosPorRango from '../../../graphql/querys/rrhh/getTraspasosPorRango.graphql';

@compose(
  graphql(getUsuario),
  graphql(deleteTraspaso, {
    name: 'deleteTraspaso',
    options: {
      refetchQueries: [{ query: getTraspasos }],
    },
  }),
  graphql(getOrganismos)
)
class VerTraspasos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      filtroOrganismo: null,
      filtroEstado: null,
      pagina: 1,
      cantidadPorPagina: 10,
      idOrganismo: null,
      fechaInicial: '',
      fechaFinal: '',
    };
  }

  componentDidMount() {
    this.buscarCantidadTraspasos();
  }

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroNombre: filtro,
        loading: true,
      },
      () => this.buscarCantidadTraspasos()
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaFiltrada,
      [
        traspaso => {
          return traspaso.fechaCreacion;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      lista: listaOrdenada,
    });
  };

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este traspaso?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteTraspaso({
            variables: { _id: id },
          })
          .then(res => {
            // console.log("La respuesta del delete fue....");
            // console.log(res);

            let id = res.data.deleteTraspaso;

            if (id) {
              notification.warning({
                message: 'Traspaso eliminado',
                description: 'Se ha eliminado el traspaso exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el traspaso');
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion el traspaso ',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  onChangeFechas = date => {
    // console.log('DATE: ', date);

    if (date) {
      this.setState(
        {
          ...this.state,
          fechaInicial: date[0] ? date[0] : '',
          fechaFinal: date[1] ? date[1] : '',
        },
        () => {
          this.buscarCantidadTraspasos();
        }
      );
    } else {
      this.setState(
        {
          ...this.state,
          fechaInicial: '',
          fechaFinal: '',
        },
        () => {
          this.buscarCantidadTraspasos();
        }
      );
    }

    // console.log('estado en cambio de fecha', this.state);
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
        loading: true,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  buscarCantidadTraspasos = () => {
    let filtros = {
      nombreSolicitante: this.state.filtroNombre,
      idOrganismo: this.state.filtroOrganismo,
      estado: this.state.filtroEstado,
    };

    if (this.state.fechaInicial !== '' && this.state.fechaFinal !== '') {
      filtros = {
        ...filtros,
        fechaInicio: this.state.fechaInicial,
        fechaFin: this.state.fechaFinal,
      };
    }

    this.props.client
      .query({
        query: getCantidadTraspasosPorFiltros,
        variables: {
          filtros: filtros,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        this.setState(
          {
            cantidadTotal: res.data.getCantidadTraspasosPorFiltros,
          },
          () => {
            this.lanzarconsulta();
          }
        );
      })
      .catch(err => {
        console.log(
          'error a la hora de buscar la cantidad total de paginas en traspasos'
        );
        console.log(err);
        errorService(err, {
          filtros: {},
        });
      });
  };

  lanzarconsulta = () => {
    this.setState({
      loadingTabla: true,
      loading: true,
    });

    let filtros = {
      nombreSolicitante: this.state.filtroNombre,
      apellidoSolicitante: this.state.filtroApellido,
      idOrganismo: this.state.filtroOrganismo,
      estado: this.state.filtroEstado,
    };

    if (this.state.fechaInicial !== '' && this.state.fechaFinal !== '') {
      filtros = {
        ...filtros,
        fechaInicio: this.state.fechaInicial,
        fechaFin: this.state.fechaFinal,
      };
    }

    this.props.client
      .query({
        query: getTraspasosConFiltros,
        variables: {
          filtros: filtros,
          pagina: this.state.pagina,
          cantidadPorPagina: this.state.cantidadPorPagina,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getTraspasosConFiltros) {
          this.setState(
            {
              listaFiltrada: res.data.getTraspasosConFiltros,
              loadingTabla: false,
              loading: false,
            },
            () => {
              this.ordenarLista(
                this.state.pagina,
                this.state.cantidadPorPagina
              );
            }
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message: 'Error a la hora de buscar los traspasos',
        });
        this.setState({
          loadingTabla: false,
          loading: false,
        });
      });
  };

  filtrarPorOrganismo = async idOrganismo => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroOrganismo: idOrganismo,
        loading: true,
      },
      () => this.buscarCantidadTraspasos()
    );
  };

  filtrarPorEstado = async estado => {
    this.setState(
      {
        ...this.state,
        filtroEstado: estado,
        loading: true,
      },

      () => this.buscarCantidadTraspasos()
    );
  };

  onDescargar = () => {
    // console.log('entre a descargar');

    let filtros = {
      nombreSolicitante: this.state.filtroNombre,
      apellidoSolicitante: this.state.filtroApellido,
      idOrganismo: this.state.filtroOrganismo,
      estado: this.state.filtroEstado,
      fechaInicio: this.state.fechaInicial,
      fechaFin: this.state.fechaFinal,
    };

    this.props.client
      .query({
        query: getTraspasosPorRango,
        variables: {
          filtros: filtros,
          pagina: this.state.pagina,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getTraspasosPorRango) {
          // console.log('response descargar', res);

          let data = _.map(res.data.getTraspasosPorRango, traspaso => {
            return {
              fecha: traspaso.fechaReal
                ? moment(traspaso.fechaReal).format('DD-MM-YYYY HH:mm')
                : moment(traspaso.fechaEstimada).format('DD-MM-YYYY HH:mm'),
              entrante:
                traspaso.usuarioEntrante.nombre +
                ' ' +
                traspaso.usuarioEntrante.apellido,
              saliente:
                traspaso.usuarioSaliente.nombre +
                ' ' +
                traspaso.usuarioSaliente.apellido,
              estado: traspaso.estado,
              organismo: traspaso.organismo.nombre,
              motivo: traspaso.motivo,
            };
          });
          descargarCSV(
            ['Fecha', 'Entrante', 'Saliente', 'Estado', 'Organismo', 'Motivo'],
            data,
            `ReporteDeTraspasos-${moment().format('DD/MM/YYYY-HH:mm')}.csv`
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message: 'Error a la hora de generar reporte de traspasos',
        });
      });
  };

  render() {
    const { loading } = this.state;

    let cargando = loading || this.props.data.loading;

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    let rangoFechas = {
      fechaInicial: this.state.fechaInicial,
      fechaFinal: this.state.fechaFinal,
    };

    return (
      <div>
        <TablaTraspasos
          traspasos={this.state.lista}
          usuario={this.props.usuario}
          history={this.props.history}
          onDelete={this.onDelete}
          pagination={pagination}
          filtrarPorNombre={this.filtrarPorNombre}
          filtroNombrePadre={this.state.filtroNombre}
          listaOrganismos={this.props.data ? this.props.data.getOrganismos : []}
          cambiarPagina={this.cambiarPagina}
          tamPagina={this.state.cantidadPorPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          pagina={this.state.pagina}
          loading={cargando}
          setFiltrarOrganismo={this.filtrarPorOrganismo}
          filtroOrganismoPadre={this.state.filtroOrganismo}
          setFiltrarEstado={this.filtrarPorEstado}
          filtroEstadoPadre={this.state.filtroEstado}
          onChange={this.onChangeFechas}
          onDescargar={this.onDescargar}
          rangoFechas={rangoFechas}
        />
      </div>
    );
  }
}

export default withApollo(VerTraspasos);
